import { temporarilyNotSupport } from '../../utils'

// 录音
export const stopRecord = /* @__PURE__ */ temporarilyNotSupport('stopRecord')
export const startRecord = /* @__PURE__ */ temporarilyNotSupport('startRecord')
export const getRecorderManager = /* @__PURE__ */ temporarilyNotSupport('getRecorderManager')
